export default __webpack_public_path__ + "static/covid-footer-magazine-img-6a0e7f464a01bc4493b93cf17a42b00f.png";